const opsCodes = {
  "8-836.0**": "Angioplastie",
  "8-83b.ba": "Ein medikamentenfreisetzender Ballon an anderen Gefäßen",
  "8-83b.bb": "Zwei medikamentenfreisetzende Ballons an anderen Gefäßen",
  "8-83b.bc": "Drei medikamentenfreisetzende Ballons an anderen Gefäßen",
  "8-83b.bd": "Vier oder mehr medikamentenfreisetzende Ballons an anderen Gefäßen",
  "8-836.1**": "Scoring- oder Cutting-Ballon",
  "8-836.2**": "Laser-Angioplastie",
  "8-836.3**": "Atherektomie",
  "8-836.w**": "Atherektomie unter peripherem Embolieschutz ",
  "8-840.0**": "Ein Stent",
  "8-840.1**": "Zwei Stents",
  "8-840.2**": "Drei Stents",
  "8-840.3**": "Vier Stents",
  "8-840.4**": "Fünf Stents",
  "8-840.5**": "Sechs oder mehr Stents",
  "8-841.0**": "Ein Stent",
  "8-841.1**": "Zwei Stents",
  "8-841.2**": "Drei Stents",
  "8-841.3**": "Vier Stents",
  "8-841.4**": "Fünf Stents",
  "8-841.5**": "Sechs oder mehr Stents",
  "8-842.0**": "Ein Stent",
  "8-842.1**": "Zwei Stents",
  "8-842.2**": "Drei Stents",
  "8-842.3**": "Vier Stents",
  "8-842.4**": "Fünf Stents",
  "8-842.5**": "Sechs oder mehr Stents",
  "8-843.0**": "Ein Stent",
  "8-843.1**": "Zwei Stents",
  "8-843.2**": "Drei Stents",
  "8-843.3**": "Vier Stents",
  "8-843.4**": "Fünf Stents",
  "8-843.5**": "Sechs oder mehr Stents",
  "8-848.0**": "Ein Stent",
  "8-848.1**": "Zwei Stents",
  "8-848.2**": "Drei Stents",
  "8-848.3**": "Vier Stents",
  "8-848.4**": "Fünf Stents",
  "8-848.5**": "Sechs oder mehr Stents",
  "8-83b.f1": "100 mm bis unter 150 mm",
  "8-83b.f2": "150 mm bis unter 200 mm",
  "8-83b.f3": "200 mm bis unter 250 mm",
  "8-83b.f4": "250 mm oder mehr",
  "8-836.7**": "Selektive Thrombolyse",
  "8-83b.j": "Verwendung eines ultraschallgestützten Thrombolysesystems",
  "8-836.8**": "Thrombektomie",
  "8-836.p**": "Rotationsthrombektomie",
  "8-83b.4": "Verwendung eines hydrodynamischen Thrombektomiesystems",
  "8-83c.70": "1 Gefäß",
  "8-83c.71": "2 Gefäße",
  "8-83c.72": "3 oder mehr Gefäße",
  "8-83b.9": "Einsatz eines Embolieprotektionssystems",
  "8-83b.a": "Verwendung von Rekanalisationssystemen",
  "8-83b.a0": "System zur Mikro-Dissektion",
  "8-83b.a1": "Spezielles Nadelsystem zur subintimalen Rekanalisation",
  "8-83b.a2": "Mechanisches Radiofrequenz-System",
  "8-83b.ax": "Sonstige",
  "8-83b.c": "Verwendung eines Gefäßverschlusssystems",
  "8-83b.c2": "Nahtsystem",
  "8-83b.c3": "Clipsystem",
  "8-83b.c4": "Polymerdichtung mit äußerer Sperrscheibe",
  "8-83b.c5": "Resorbierbare Plugs ohne Anker",
  "8-83b.c6": "Resorbierbare Plugs mit Anker",
  "8-83b.03": "Paclitaxel-freisetzende Stents ohne Polymer",
  "8-83b.05": "Paclitaxel-freisetzende Stents mit biologisch abbaubarer Polymerbeschichtung",
  "8-83b.06": "Paclitaxel-freisetzende Stents mit sonstigem Polymer",
  "8-83b.07": "Sirolimus-freisetzende Stents ohne Polymer",
  "8-83b.08": "Sirolimus-freisetzende Stents mit Polymer",
  "8-83b.09": "Tacrolimus-freisetzende Stents",
  "8-83b.0b": "Everolimus-freisetzende Stents mit biologisch abbaubarer Polymerbeschichtung",
  "8-83b.0c": "Everolimus-freisetzende Stents mit sonstigem Polymer",
}, 
opsRegionen = {
  'Aorta': {'8-836.0**': '04', 'default': '4'},
  'Andere Gefäße thorakal': {'8-836.0**': '08', 'default': '8'},
  'Andere Gefäße abdominal und pelvin': {'8-836.0**': '0q', '8-836.1**': 'h', '8-836.2**': 'h', '8-836.3**': 'h', '8-836.w**': 'h', '8-836.7**': 'h', '8-836.8**': 'h', '8-836.p**': 'h', 'default': 'q'},
  'Gefäße viszeral': {'8-836.0**': '0a', 'default': 'a'},
  'Gefäße Oberschenkel – femoral': {'8-836.0**': '0s', '8-836.1**': 'k', '8-836.2**': 'k', '8-836.3**': 'k', '8-836.w**': 'k', '8-836.7**': 'k', '8-836.8**': 'k', '8-836.p**': 'k', 'default': 's'},
  'Gefäße Oberschenkel - popliteal': {'8-836.0**': '0s', '8-836.1**': 'k', '8-836.2**': 'k', '8-836.3**': 'k', '8-836.w**': 'k', '8-836.7**': 'k', '8-836.8**': 'k', '8-836.p**': 'k', 'default': 's'},
  'Gefäße Unterschenkel': {'8-836.0**': '0c', 'default': 'c'},
  'Künstliche Gefäße': {'8-836.0**': '0e', 'default': 'e'},
  'Sonstige': {'8-836.0**': '0x', 'default': 'x'},
};

export const config = {
  'urls': {
    'news': '/api/news?projection=default',
    'center': '/api/center?projection=default',
    'networks': '/api/networks',
    'protocol': '/api/logging',
    'patients': '/api/patients',
    'users': '/api/users',
    'targetlesions': '/api/targetlesions',
    //'statistics': '/api/statistics',
    'messages': '/api/messages',
    'settings': '/api/settings/search/global',
    'contact': '/api/contact'
  },
  'labels': {
    "ARTERIAL": "arteriell",
    "FOLLOWUP": "Follow-Up",
    "INTERVENTION": "Intervention",
    "ANAMNESIS": "Ersterfassung",
    "POSTINTERVATIONELLENACHKONTROLLE": "Postinterventionelle Nachkontrolle",
    "TAKING": "Einnahme",
    "NO_TAKING": "Keine Einnahme",
    "UNKNOWN": "Unbekannt",
    "aspirin": "Aspirin",
    "antipsychotica": "Antipsychotica",
    "antihypertensiva": "Antihypertensiva",
    "antidepressiva": "Antidepressiva",
    "antiandrogene": "Antiandrogene",
    "antihistaminika": "Antihistaminika",
    "pde_5_i": "PDE-5-I",
    "plavix": "Plavix",
    "oak": "OAK",
    "andere": "Andere Medikation",
    "ACCEPTED": "Angenommen",
    "DECLINED": "Abgelehnt",
    "OPEN": "Offen"
  },
  'icdCodes': {
    "I70.8": "I70.8 Atherosklerose sonstiger Arterien"
  },
  'opsCodes': opsCodes,
  'opsRegionen': opsRegionen,
  'opsWizardSchema': {
    "title": "OPS-Wizard",
    "type": "object",
    "properties": {
      "angioplastie": {
        "type": "string",
        "title": "Angioplastie",
        "enum": ["8-836.0**", "8-83b.ba", "8-83b.bb", "8-83b.bc", "8-83b.bd"],
        "x-schema-form": {
          "type": "radios",
          "titleMap": [
            { "value": "8-836.0**", "name": opsCodes["8-836.0**"] },
            { "value": "8-83b.ba", "name": opsCodes["8-83b.ba"] },
            { "value": "8-83b.bb", "name": opsCodes["8-83b.bb"] },
            { "value": "8-83b.bc", "name": opsCodes["8-83b.bc"] },
            { "value": "8-83b.bd", "name": opsCodes["8-83b.bd"] }
          ]
        }
      },
      "scoring_ballon": {
        "title": "Scoring- oder Cutting-Ballon",
        "type": "string",
        "enum": ["8-836.1**"],
        "x-schema-form": {
          "type": "radios-inline",
          "titleMap": [
            { "value": "8-836.1**", "name": opsCodes["8-836.1**"] },
          ]
        }
      },
      "laser_angio": {
        "title": "Laser-Angioplastie",
        "type": "string",
        "enum": ["8-836.2**"],
        "x-schema-form": {
          "type": "radios-inline",
          "titleMap": [
            { "value": "8-836.2**", "name": opsCodes["8-836.2**"] },
          ]
        }
      },
      "atherektomie": {
        "title": "Atherektomie",
        "type": "string",
        "enum": ["8-836.3**", "8-836.w**"],
        "x-schema-form": {
          "type": "radios",
          "titleMap": [
            { "value": "8-836.3**", "name": opsCodes["8-836.3**"] },
            { "value": "8-836.w**", "name": opsCodes["8-836.w**"] }
          ]
        }
      },
      "nicht_medfrei_stents": {
        "type": "string",
        "title": "Implantation von nicht medikamentenfreisetzenden Stents",
        "enum": ["8-840.0**", "8-840.1**", "8-840.2**", "8-840.3**", "8-840.4**", "8-840.5**"],
        "x-schema-form": {
          "type": "radios-inline", 
          "titleMap": [
            { "value": "8-840.0**", "name": opsCodes["8-840.0**"] },
            { "value": "8-840.1**", "name": opsCodes["8-840.1**"] },
            { "value": "8-840.2**", "name": opsCodes["8-840.2**"] },
            { "value": "8-840.3**", "name": opsCodes["8-840.3**"] },
            { "value": "8-840.4**", "name": opsCodes["8-840.4**"] },
            { "value": "8-840.5**", "name": opsCodes["8-840.5**"] }
          ]
        }
      },
      "medfrei_stents": {
        "type": "string",
        "title": "Implantation von medikamentenfreisetzenden Stents",
        "enum": ["8-841.0**", "8-841.1**", "8-841.2**", "8-841.3**", "8-841.4**", "8-841.5**"],
        "x-schema-form": {
          "type": "radios-inline",
          "titleMap": [
            { "value": "8-841.0**", "name": opsCodes["8-841.0**"] },
            { "value": "8-841.1**", "name": opsCodes["8-841.1**"] },
            { "value": "8-841.2**", "name": opsCodes["8-841.2**"] },
            { "value": "8-841.3**", "name": opsCodes["8-841.3**"] },
            { "value": "8-841.4**", "name": opsCodes["8-841.4**"] },
            { "value": "8-841.5**", "name": opsCodes["8-841.5**"] }
          ]
        }
      },
      "medfrei_art": {
        "title": "Art des freigesetzten Medikaments",
        "type": "string",
        "enum": ["8-83b.03", "8-83b.05", "8-83b.06", "8-83b.07", "8-83b.08", "8-83b.09", "8-83b.0b", "8-83b.0c"],
        "x-schema-form": {
          "type": "radios",
          "titleMap": [
            { "value": "8-83b.03", "name": opsCodes["8-83b.03"] },
            { "value": "8-83b.05", "name": opsCodes["8-83b.05"] },
            { "value": "8-83b.06", "name": opsCodes["8-83b.06"] },
            { "value": "8-83b.07", "name": opsCodes["8-83b.07"] },
            { "value": "8-83b.08", "name": opsCodes["8-83b.08"] },
            { "value": "8-83b.09", "name": opsCodes["8-83b.09"] },
            { "value": "8-83b.0b", "name": opsCodes["8-83b.0b"] },
            { "value": "8-83b.0c", "name": opsCodes["8-83b.0c"] },
          ]
        }
      },
      "nicht_medfrei_stents_graft": {
        "type": "string",
        "title": "Implantation von nicht medikamentenfreisetzenden gecoverten Stents (Stent-Graft)",
        "enum": ["8-842.0**", "8-842.1**", "8-842.2**", "8-842.3**", "8-842.4**", "8-842.5**"],
        "x-schema-form": {
          "type": "radios-inline",
          "titleMap": [
            { "value": "8-842.0**", "name": opsCodes["8-842.0**"] },
            { "value": "8-842.1**", "name": opsCodes["8-842.1**"] },
            { "value": "8-842.2**", "name": opsCodes["8-842.2**"] },
            { "value": "8-842.3**", "name": opsCodes["8-842.3**"] },
            { "value": "8-842.4**", "name": opsCodes["8-842.4**"] },
            { "value": "8-842.5**", "name": opsCodes["8-842.5**"] }
          ]
        }
      },
      "biores_stents": {
        "type": "string",
        "title": "Implantation von bioresorbierbaren Stents",
        "enum": ["8-843.0**", "8-843.1**", "8-843.2**", "8-843.3**", "8-843.4**", "8-843.5**"],
        "x-schema-form": {
          "type": "radios-inline",
          "titleMap": [
            { "value": "8-843.0**", "name": opsCodes["8-843.0**"] },
            { "value": "8-843.1**", "name": opsCodes["8-843.1**"] },
            { "value": "8-843.2**", "name": opsCodes["8-843.2**"] },
            { "value": "8-843.3**", "name": opsCodes["8-843.3**"] },
            { "value": "8-843.4**", "name": opsCodes["8-843.4**"] },
            { "value": "8-843.5**", "name": opsCodes["8-843.5**"] }
          ]
        }
      },
      "medfrei_stents_graft": {
        "type": "string",
        "title": "Implantation von medikamentenfreisetzenden gecoverten Stents (Stent-Graft)",
        "enum": ["8-848.0**", "8-848.1**", "8-848.2**", "8-848.3**", "8-848.4**", "8-848.5**"],
        "x-schema-form": {
          "type": "radios-inline",
          "titleMap": [
            { "value": "8-848.0**", "name": opsCodes["8-848.0**"] },
            { "value": "8-848.1**", "name": opsCodes["8-848.1**"] },
            { "value": "8-848.2**", "name": opsCodes["8-848.2**"] },
            { "value": "8-848.3**", "name": opsCodes["8-848.3**"] },
            { "value": "8-848.4**", "name": opsCodes["8-848.4**"] },
            { "value": "8-848.5**", "name": opsCodes["8-848.5**"] }
          ]
        }
      },
      "laenge_periphere_stents": {
        "type": "string",
        "title": "Länge der peripheren Stents",
        "enum": ["8-83b.f1", "8-83b.f2", "8-83b.f3", "8-83b.f4"],
        "x-schema-form": {
          "type": "radios-inline",
          "titleMap": [
            { "value": "8-83b.f1", "name": opsCodes["8-83b.f1"] },
            { "value": "8-83b.f2", "name": opsCodes["8-83b.f2"] },
            { "value": "8-83b.f3", "name": opsCodes["8-83b.f3"] },
            { "value": "8-83b.f4", "name": opsCodes["8-83b.f4"] }
          ]
        }
      },
      "thrombolyse": {
        "type": "string",
        "title": "Thrombolyse",
        "enum": ["8-836.7**", "8-83b.j"],
        "x-schema-form": {
          "type": "radios-inline",
          "titleMap": [
            { "value": "8-836.7**", "name": opsCodes["8-836.7**"] },
            { "value": "8-83b.j", "name": opsCodes["8-83b.j"] }
          ]
        }
      },
      "thrombektomie": {
        "type": "string",
        "title": "Thrombektomie",
        "enum": ["8-836.8**", "8-836.p**", "8-83b.4"],
        "x-schema-form": {
          "type": "radios",
          "titleMap": [
            { "value": "8-836.8**", "name": opsCodes["8-836.8**"] },
            { "value": "8-836.p**", "name": opsCodes["8-836.p**"] },
            { "value": "8-83b.4", "name": opsCodes["8-83b.4"] }
          ]
        }
      },
      "spasmolyse": {
        "type": "string",
        "title": "Intraarterielle Spasmolyse",
        "enum": ["8-83c.70", "8-83c.71", "8-83c.72"],
        "x-schema-form": {
          "type": "radios-inline",
          "titleMap": [
            { "value": "8-83c.70", "name": opsCodes["8-83c.70"] },
            { "value": "8-83c.71", "name": opsCodes["8-83c.71"] },
            { "value": "8-83c.72", "name": opsCodes["8-83c.72"] }
          ]
        }
      },
      "embolie_protekt": {
        "type": "string",
        "title": "Einsatz eines Embolieprotektionssystems",
        "enum": ["8-83b.9"],
        "x-schema-form": {
          "type": "radios-inline",
          "titleMap": [
            { "value": "8-83b.9", "name": opsCodes["8-83b.9"] }
          ],
          "condition": "model.atherektomie !== '8-836.w**'"
        }
      },
      "rekanalisationssystem": {
        "type": "string",
        "title": "Rekanalisationssysteme",
        "enum": ["8-83b.a", "8-83b.a0", "8-83b.a1", "8-83b.a2", "8-83b.ax"],
        "x-schema-form": {
          "type": "radios",
          "titleMap": [
            { "value": "8-83b.a", "name": opsCodes["8-83b.a"] },
            { "value": "8-83b.a0", "name": opsCodes["8-83b.a0"] },
            { "value": "8-83b.a1", "name": opsCodes["8-83b.a1"] },
            { "value": "8-83b.a2", "name": opsCodes["8-83b.a2"] },
            { "value": "8-83b.ax", "name": opsCodes["8-83b.ax"] }
          ]
        }
      },
      "verschlusssystem": {
        "type": "string",
        "title": "Gefäßverschlusssysteme",
        "enum": ["8-83b.c", "8-83b.c2", "8-83b.c3", "8-83b.c4", "8-83b.c5", "8-83b.c6"],
        "x-schema-form": {
          "type": "radios",
          "titleMap": [
            { "value": "8-83b.c", "name": opsCodes["8-83b.c"] },
            { "value": "8-83b.c2", "name": opsCodes["8-83b.c2"] },
            { "value": "8-83b.c3", "name": opsCodes["8-83b.c3"] },
            { "value": "8-83b.c4", "name": opsCodes["8-83b.c4"] },
            { "value": "8-83b.c5", "name": opsCodes["8-83b.c5"] },
            { "value": "8-83b.c6", "name": opsCodes["8-83b.c6"] }
          ]
        }
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/main/webapp-files/modules/app/app.config.js